module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/InglouriousBasterds.0b041c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/InglouriousBasterds.jpg
// module id = v6am
// module chunks = 0